import React from 'react';
import styles from './switcher.module.scss';

interface SwitcherProps {
  isActive: boolean;
  onClick: () => void;
}

export const Switcher: React.FC<SwitcherProps> = ({ isActive, onClick }) => {
  return (
    <div
      className={`${styles.switcher} ${
        isActive ? styles.switcher__active : styles.switcher_not_active
      }`}
      onClick={onClick}
    >
      <div className={styles.switcher__circle} />
    </div>
  );
};
